import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { database } from '../supabase';

export const useSubscription = () => {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubscription = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const userData = await database.getUserByFirebaseUid(user.uid);
        
        if (userData) {
          setSubscription({
            status: userData.subscription_status || 'free',
            plan: userData.subscription_plan || 'free',
            endDate: userData.subscription_end_date,
            stripeCustomerId: userData.stripe_customer_id
          });
        }
      } catch (err) {
        console.error('Error fetching subscription:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [user]);

  const isActive =
    subscription?.status === 'active' || subscription?.status === 'trialing';
  const isPro = subscription?.plan === 'pro';
  const isEnterprise = subscription?.plan === 'enterprise';
  const isFree = subscription?.plan === 'free';

  return {
    subscription,
    loading,
    error,
    isActive,
    isPro,
    isEnterprise,
    isFree,
    hasAccess: (feature) => {
      if (!subscription) return false;
      
      switch (feature) {
        case 'unlimited_quizzes':
          return isPro || isEnterprise;
        case 'advanced_features':
          return isPro || isEnterprise;
        case 'priority_support':
          return isEnterprise;
        case 'api_access':
          return isEnterprise;
        default:
          return false;
      }
    }
  };
};
